import Vuetify from "vuetify/lib";
import IPlugin from "./plugin";
import '@mdi/font/css/materialdesignicons.css'

export default class VuetifyPlugin extends IPlugin {
    setup(Vue, config) {
        Vue.use(Vuetify);

        config.vuetify = new Vuetify({
            icons: {
                iconfont: "mdiSvg",
            },
            theme: {
                themes: {
                    light: {
                        "gappt-grey": '#333333',
                        "gappt-orange": '#f57d1c',
                    },
                },
                dark: false,
            },
        });

        return super.setup(Vue, config);
    }
}